export var ProductModalSource;
(function (ProductModalSource) {
    ProductModalSource["SHOPPING_BAG"] = "SHOPPING_BAG";
    ProductModalSource["PRODUCTS_PINNED"] = "PRODUCTS_PINNED";
})(ProductModalSource || (ProductModalSource = {}));
export var ILiveStreamState;
(function (ILiveStreamState) {
    ILiveStreamState["ACTIVE_WAITING"] = "ACTIVE_WAITING";
    ILiveStreamState["ACTIVE_PLAYING"] = "ACTIVE_PLAYING";
    ILiveStreamState["ACTIVE_PAUSED"] = "ACTIVE_PAUSED";
    ILiveStreamState["REPLAY_PLAYING"] = "REPLAY_PLAYING";
    ILiveStreamState["CONNECTION_ISSUE"] = "CONNECTION_ISSUE";
})(ILiveStreamState || (ILiveStreamState = {}));
export var ILiveStreamChatInputState;
(function (ILiveStreamChatInputState) {
    ILiveStreamChatInputState["PUBLIC"] = "PUBLIC";
    ILiveStreamChatInputState["PRIVATE"] = "PRIVATE";
})(ILiveStreamChatInputState || (ILiveStreamChatInputState = {}));
